import { parseReferences } from "@/frontend/utils/parseReferences";
import { YamlEditor } from "./YamlEditor";
import { autocompletion } from '@codemirror/autocomplete';
import { customCompletion, methodNameLinter, unquotedBracesLinter } from "@/frontend/utils/customCodeMirror";
import { parseTaskKeys } from "@/frontend/utils/parseTaskKeys";
import { useGetAllInputParametersForOperation } from "@/frontend/hooks/parameters";
import { Operation } from "@/backend/models/operation";


export function CommandingEditor(props: { value: string, label: string, onBlur: (value: string) => Promise<void>, operation: Operation }) {
  const { value, label, onBlur, operation } = props;
  const parameters = useGetAllInputParametersForOperation(operation);
  const extensions = [
    autocompletion({ override: [customCompletion()] }),
    unquotedBracesLinter,
    methodNameLinter
  ];

  const onChange = (input: string) => {
    parseTaskKeys(input);
    const error = parseReferences(input, parameters);
    if (error) {
      throw new Error(error);
    }
  };

  return (
    <YamlEditor
      extensions={extensions}
      value={value}
      onBlur={onBlur}
      onChange={onChange}
      label={label}
    />
  );
}
